var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 426,
    height: 294,
    viewBox: "0 0 426 294",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 426,
    height: 294,
    fill: "#FDF7ED"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.1196 240.688H376.501",
    stroke: "#455A64",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M331.128 44.0247V45.9326",
    stroke: "#455A64",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M331.128 48.0845V49.9924",
    stroke: "#455A64",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M328.152 47.0085H330.055",
    stroke: "#455A64",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M332.2 47.0085H334.103",
    stroke: "#455A64",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M141.095 55.0859V56.9939",
    stroke: "#455A64",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M141.095 59.1453V61.0532",
    stroke: "#455A64",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M138.12 58.0693H140.023",
    stroke: "#455A64",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M142.168 58.0693H144.071",
    stroke: "#455A64",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M374.909 127.853V129.761",
    stroke: "#455A64",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M374.909 131.912V133.82",
    stroke: "#455A64",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M371.934 130.836H373.836",
    stroke: "#455A64",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M375.982 130.836H377.885",
    stroke: "#455A64",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M64.6025 174.974V176.882",
    stroke: "#455A64",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M64.6025 179.034V180.942",
    stroke: "#455A64",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M61.627 177.958H63.5296",
    stroke: "#455A64",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M65.675 177.958H67.5777",
    stroke: "#455A64",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M376.508 201.704C373.924 202.781 370.929 205.703 368.886 208.443C368.159 209.42 367.252 211.231 366.793 212.315C365.644 215.023 365.038 218.397 365.294 218.642C365.837 219.161 369.233 216.026 370.085 215.077C372.453 212.438 374.406 210.071 375.618 206.728C375.85 206.085 377.348 201.353 376.508 201.704Z",
    fill: "#455A64"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M379.133 219.836C377.006 219.252 373.732 219.617 371.139 220.33C370.216 220.584 368.778 221.272 367.969 221.723C365.947 222.849 363.943 224.655 363.984 224.931C364.071 225.518 367.697 225.215 368.684 225.038C371.431 224.546 373.787 224.021 376.154 222.529C376.61 222.243 379.825 220.026 379.133 219.836Z",
    fill: "#455A64"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M353.609 212.844C352.779 215.145 352.89 218.797 353.446 221.728C353.644 222.771 354.273 224.423 354.697 225.357C355.758 227.692 357.566 230.069 357.874 230.048C358.527 230.003 358.515 225.967 358.407 224.859C358.108 221.778 357.74 219.125 356.308 216.376C356.033 215.847 353.878 212.096 353.609 212.844Z",
    fill: "#455A64"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M364.925 219.636C361.116 225.861 359.622 229.293 357.027 240.669",
    stroke: "#455A64",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M351.029 161.52L356.752 158.754L362.754 161.477L371.756 157.142L379.076 162.041V169.967L351.029 170.076V161.52Z",
    stroke: "#FAAE20",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M365.222 164.715L379.724 158.068C379.724 158.068 379.778 168.106 379.778 169.967C379.778 171.63 378.494 171.53 378.22 171.49C378.176 171.484 378.132 171.481 378.088 171.481H352.191C352.191 171.481 350.743 171.481 350.666 170.077C350.588 168.672 350.666 159.135 350.666 159.135L365.222 164.715Z",
    fill: "#FAAE20"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M378.702 150.168C379.297 150.168 379.779 150.651 379.779 151.248V170.457C379.779 171.023 379.321 171.481 378.758 171.481H351.686C351.123 171.481 350.666 171.022 350.666 170.457V151.248C350.666 150.652 351.148 150.168 351.742 150.168H378.702Z",
    stroke: "#FAAE20",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M357.943 153.252C358.828 153.252 359.544 153.962 359.544 154.838C359.544 155.713 358.828 156.423 357.943 156.423C357.059 156.423 356.342 155.713 356.342 154.838C356.342 153.961 357.059 153.252 357.943 153.252Z",
    fill: "#FAAE20"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M337.004 69.6199C337.004 68.5421 337.876 67.668 338.951 67.668H350.513C351.588 67.668 352.459 68.5421 352.459 69.6199V139.11C352.459 140.189 351.588 141.062 350.513 141.062H338.951C337.876 141.062 337.004 140.188 337.004 139.11V69.6199Z",
    fill: "white"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M339.66 82.7001C339.66 81.6256 340.529 80.7549 341.6 80.7549H347.858C348.929 80.7549 349.798 81.6261 349.798 82.7001V88.9756C349.798 90.0501 348.929 90.9208 347.858 90.9208H341.6C340.528 90.9208 339.66 90.0496 339.66 88.9756V82.7001Z",
    fill: "#FAAE20"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M339.663 101.783C339.663 100.708 340.532 99.8374 341.603 99.8374H347.861C348.932 99.8374 349.801 100.708 349.801 101.783V108.058C349.801 109.133 348.932 110.003 347.861 110.003H341.603C340.532 110.003 339.663 109.132 339.663 108.058V101.783Z",
    fill: "#455A64"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M339.66 120.865C339.66 119.791 340.529 118.92 341.6 118.92H347.858C348.929 118.92 349.798 119.791 349.798 120.865V127.141C349.798 128.215 348.929 129.086 347.858 129.086H341.6C340.528 129.086 339.66 128.215 339.66 127.141V120.865Z",
    fill: "#455A64"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M337.004 69.6199C337.004 68.5421 337.876 67.668 338.951 67.668H350.513C351.588 67.668 352.459 68.5421 352.459 69.6199V139.11C352.459 140.189 351.588 141.062 350.513 141.062H338.951C337.876 141.062 337.004 140.188 337.004 139.11V69.6199Z",
    stroke: "#455A64",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M337.004 69.0338C337.004 68.2793 337.517 67.668 338.148 67.668H351.316C351.948 67.668 352.46 68.2793 352.46 69.0338V72.1H337.004V69.0338Z",
    fill: "#455A64"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M321.671 169.187C321.671 168.644 322.111 168.203 322.653 168.203C323.195 168.203 323.634 168.644 323.634 169.187C323.634 169.731 323.194 170.171 322.653 170.171C322.111 170.171 321.671 169.731 321.671 169.187Z",
    fill: "white"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M318.639 169.187C318.639 168.644 319.079 168.203 319.621 168.203C320.163 168.203 320.602 168.644 320.602 169.187C320.602 169.731 320.163 170.171 319.621 170.171C319.079 170.171 318.639 169.731 318.639 169.187Z",
    fill: "white"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M324.704 169.187C324.704 168.644 325.143 168.203 325.685 168.203C326.227 168.203 326.666 168.644 326.666 169.187C326.666 169.731 326.227 170.171 325.685 170.171C325.143 170.171 324.704 169.731 324.704 169.187Z",
    fill: "white"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M368.414 56.3962C368.771 56.0395 369.347 56.0395 369.704 56.3962L375.538 62.2468C375.894 62.6035 375.894 63.1824 375.538 63.5391L354.529 84.6066C354.375 84.7605 354.172 84.8544 353.957 84.8714L349.117 85.2576C348.902 85.275 348.699 85.3684 348.545 85.5219L347.551 86.5199C347.197 86.8746 346.623 86.8771 346.267 86.5252L345.597 85.864C345.236 85.5083 345.233 84.9256 345.592 84.5664L346.585 83.5699C346.743 83.4121 346.837 83.2016 346.85 82.9789L347.148 78.0475C347.161 77.8248 347.255 77.6143 347.413 77.4565L368.414 56.3962Z",
    stroke: "#455A64",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M379.591 46.3503C379.03 45.7879 378.129 45.7966 377.568 46.359L369.647 54.3025L369.046 53.6999C368.774 53.4274 368.336 53.4274 368.064 53.6999L367.015 54.7521C366.743 55.0246 366.743 55.4641 367.015 55.7365L376.197 64.9446C376.469 65.2171 376.907 65.2171 377.179 64.9446L378.228 63.8924C378.5 63.6199 378.5 63.1805 378.228 62.908L377.627 62.3054L385.549 54.362C386.109 53.7996 386.109 52.8872 385.549 52.3253L379.591 46.3503Z",
    fill: "#455A64"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M359.415 66.8163C359.499 66.7326 359.62 66.6977 359.735 66.7244L368.229 68.6662C368.492 68.7262 368.586 69.0534 368.395 69.245L353.945 83.735C353.888 83.7916 353.813 83.827 353.734 83.8342L348.905 84.2737C348.828 84.281 348.755 84.3144 348.699 84.3681L347.775 85.2557C347.641 85.3855 347.427 85.383 347.295 85.2509L346.912 84.8671C346.782 84.7359 346.778 84.5249 346.904 84.3899L347.776 83.4485C347.83 83.3899 347.863 83.3139 347.867 83.2336L348.149 78.2377C348.154 78.1535 348.19 78.0737 348.249 78.0141L359.415 66.8163Z",
    fill: "#FAAE20"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M330.202 68.9512H90.6753C89.8755 68.9512 89.2273 69.6012 89.2273 70.4032V221.84C89.2273 222.641 89.8755 223.292 90.6753 223.292H330.202C331.001 223.292 331.65 222.641 331.65 221.84V70.4032C331.65 69.6017 331.001 68.9512 330.202 68.9512Z",
    stroke: "#FAAE20",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M330.202 68.9512H90.6753C89.8755 68.9512 89.2273 69.6012 89.2273 70.4032V77.3471H331.65V70.4032C331.65 69.6017 331.001 68.9512 330.202 68.9512Z",
    fill: "#FAAE20"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M311.452 73.1493C311.452 72.3043 312.135 71.6199 312.977 71.6199C313.82 71.6199 314.503 72.3043 314.503 73.1493C314.503 73.9944 313.82 74.6788 312.977 74.6788C312.135 74.6788 311.452 73.9944 311.452 73.1493Z",
    fill: "white"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M317.328 73.1493C317.328 72.3043 318.011 71.6199 318.853 71.6199C319.696 71.6199 320.379 72.3043 320.379 73.1493C320.379 73.9944 319.696 74.6788 318.853 74.6788C318.011 74.6788 317.328 73.9944 317.328 73.1493Z",
    fill: "white"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M323.204 73.1493C323.204 72.3043 323.887 71.6199 324.73 71.6199C325.572 71.6199 326.255 72.3043 326.255 73.1493C326.255 73.9944 325.572 74.6788 324.73 74.6788C323.887 74.6788 323.204 73.9944 323.204 73.1493Z",
    fill: "white"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M288.125 86.3185L287.261 87.3954C286.792 87.2846 286.323 87.2144 285.85 87.1907L285.296 85.8921L281.445 86.8799L281.54 88.2167C280.977 88.5376 280.456 88.9331 279.98 89.3924L278.652 88.9084L276.736 92.3966L277.783 93.2474C277.647 93.8181 277.572 94.3921 277.564 94.9681L276.337 95.5813L277.449 99.4078L278.735 99.2384C279.022 99.7069 279.359 100.143 279.745 100.549L279.25 101.85L282.696 103.829L283.58 102.77C284.084 102.893 284.591 102.968 285.1 102.99L285.683 104.269L289.534 103.282L289.402 101.936C289.963 101.611 290.482 101.214 290.956 100.75L292.281 101.197L294.198 97.7089L293.126 96.8799C293.256 96.3184 293.328 95.7546 293.335 95.1888L294.638 94.5775L293.527 90.7505L292.136 90.8952C291.845 90.4272 291.502 89.9921 291.112 89.5889L291.571 88.2971L288.125 86.3185ZM286.183 93.7997C286.896 94.2096 287.143 95.1229 286.735 95.8388C286.326 96.5541 285.418 96.7976 284.704 96.3881C283.991 95.9782 283.741 95.0692 284.15 94.3539C284.558 93.638 285.469 93.3897 286.183 93.7997Z",
    fill: "#FAAE20"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M310.471 91.7053L309.343 92.9264C308.79 92.7536 308.232 92.6302 307.666 92.5615L307.108 90.9561L302.401 91.819L302.404 93.4322C301.701 93.7705 301.042 94.2018 300.432 94.7133L298.878 94.0207L296.285 98.0491L297.472 99.1589C297.26 99.8331 297.122 100.516 297.065 101.207L295.54 101.84L296.555 106.529L298.114 106.434C298.42 107.02 298.788 107.574 299.217 108.093L298.514 109.614L302.487 112.281L303.637 111.082C304.232 111.272 304.834 111.405 305.444 111.474L306.037 113.06L310.744 112.197L310.699 110.57C311.4 110.226 312.057 109.793 312.664 109.276L314.219 109.924L316.812 105.896L315.595 104.81C315.798 104.147 315.931 103.476 315.986 102.797L317.602 102.172L316.587 97.4833L314.904 97.5404C314.594 96.9543 314.218 96.4025 313.784 95.8851L314.443 94.3726L310.471 91.7053ZM307.514 100.527C308.336 101.079 308.557 102.197 308.007 103.022C307.455 103.847 306.345 104.063 305.522 103.511C304.699 102.958 304.475 101.846 305.025 101.021C305.576 100.196 306.691 99.9749 307.514 100.527Z",
    stroke: "#455A64",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M210.628 173.408C210.628 172.645 211.245 172.025 212.008 172.025H239.778C240.54 172.025 241.158 172.645 241.158 173.408V202.514C241.158 203.278 240.54 203.897 239.778 203.897H212.008C211.245 203.897 210.628 203.278 210.628 202.514V173.408Z",
    fill: "white"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M221.785 181.398H236.621",
    stroke: "#455A64",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M221.785 184.783H236.621",
    stroke: "#455A64",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M215.388 188.169H236.621",
    stroke: "#455A64",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M215.388 191.554H236.621",
    stroke: "#455A64",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M215.388 194.939H236.621",
    stroke: "#455A64",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M215.388 198.324H236.621",
    stroke: "#455A64",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M215.163 181.536C215.163 181.172 215.458 180.877 215.821 180.877H218.644C219.007 180.877 219.302 181.172 219.302 181.536V184.367C219.302 184.731 219.007 185.027 218.644 185.027H215.821C215.458 185.027 215.163 184.731 215.163 184.367V181.536Z",
    fill: "#FAAE20"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M210.314 173.258C210.314 172.295 211.346 171.514 212.62 171.514H239.166C240.439 171.514 241.472 172.295 241.472 173.258V177.173H210.314V173.258H210.314Z",
    fill: "#455A64"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M216.496 174.606C216.496 174.063 216.936 173.622 217.478 173.622C218.02 173.622 218.459 174.063 218.459 174.606C218.459 175.15 218.02 175.59 217.478 175.59C216.936 175.59 216.496 175.15 216.496 174.606Z",
    fill: "white"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M213.464 174.606C213.464 174.063 213.904 173.622 214.446 173.622C214.988 173.622 215.427 174.063 215.427 174.606C215.427 175.15 214.988 175.59 214.446 175.59C213.904 175.59 213.464 175.15 213.464 174.606Z",
    fill: "white"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M219.529 174.606C219.529 174.063 219.968 173.622 220.51 173.622C221.052 173.622 221.491 174.063 221.491 174.606C221.491 175.15 221.052 175.59 220.51 175.59C219.968 175.59 219.529 175.15 219.529 174.606Z",
    fill: "white"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M210.628 173.408C210.628 172.645 211.245 172.025 212.008 172.025H239.778C240.54 172.025 241.158 172.645 241.158 173.408V202.514C241.158 203.278 240.54 203.897 239.778 203.897H212.008C211.245 203.897 210.628 203.278 210.628 202.514V173.408Z",
    stroke: "#455A64",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M278.165 116.845H293",
    stroke: "#455A64",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M278.165 120.23H293",
    stroke: "#455A64",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M271.767 123.615H293",
    stroke: "#455A64",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M271.767 127H293",
    stroke: "#455A64",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M271.767 130.385H293",
    stroke: "#455A64",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M271.767 133.77H293",
    stroke: "#455A64",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M271.542 116.982C271.542 116.618 271.837 116.323 272.2 116.323H275.023C275.386 116.323 275.681 116.618 275.681 116.982V119.813C275.681 120.177 275.386 120.473 275.023 120.473H272.2C271.837 120.473 271.542 120.177 271.542 119.813V116.982Z",
    fill: "#455A64"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M214.807 122.29H222.769",
    stroke: "#455A64",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M218.788 122.29V131.019",
    stroke: "#455A64",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M225.893 122.29H255.441",
    stroke: "#455A64",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M225.893 126.313H255.441",
    stroke: "#455A64",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M225.893 130.336H255.441",
    stroke: "#455A64",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M215.674 134.359H255.44",
    stroke: "#455A64",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M215.674 138.382H255.44",
    stroke: "#455A64",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M215.674 142.405H255.44",
    stroke: "#455A64",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M215.674 146.428H255.44",
    stroke: "#455A64",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M215.674 150.451H255.44",
    stroke: "#455A64",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M211.274 116.291C211.275 116.305 211.259 116.999 211.259 117.002H212.74C212.961 117.002 213.147 116.849 213.147 116.654C213.147 116.458 212.961 116.291 212.74 116.291H211.274ZM216.35 116.291C216.128 116.291 215.958 116.458 215.958 116.654C215.958 116.85 216.129 117.002 216.35 117.002H219.553C219.774 117.002 219.961 116.849 219.961 116.654C219.961 116.458 219.774 116.291 219.553 116.291H216.35ZM223.164 116.291C222.942 116.291 222.771 116.458 222.771 116.654C222.771 116.85 222.943 117.002 223.164 117.002H226.366C226.588 117.002 226.774 116.849 226.774 116.654C226.774 116.458 226.587 116.291 226.366 116.291H223.164ZM229.977 116.291C229.755 116.291 229.584 116.458 229.584 116.654C229.584 116.85 229.756 117.002 229.977 117.002L233.436 117.017C233.658 117.017 233.829 116.849 233.829 116.654C233.829 116.458 233.657 116.306 233.436 116.306L229.977 116.291ZM239.993 116.291L237.077 116.306C236.856 116.306 236.685 116.458 236.685 116.654C236.685 116.85 236.856 117.017 237.077 117.017L239.993 117.002C240.214 117.002 240.401 116.849 240.401 116.654C240.401 116.458 240.214 116.291 239.993 116.291ZM243.604 116.291C243.382 116.291 243.211 116.458 243.211 116.654C243.211 116.85 243.383 117.002 243.604 117.002H246.806C247.028 117.002 247.214 116.849 247.214 116.654C247.214 116.458 247.027 116.291 246.806 116.291H243.604ZM250.417 116.291C250.195 116.291 250.024 116.458 250.024 116.654C250.024 116.85 250.195 117.002 250.417 117.002H253.619C253.841 117.002 254.027 116.849 254.027 116.654C254.027 116.458 253.841 116.291 253.619 116.291H250.417ZM257.23 116.291C257.009 116.291 256.837 116.458 256.837 116.654C256.837 116.85 257.009 117.002 257.23 117.002L259.451 117.017C259.672 117.017 259.843 116.849 259.843 116.654C259.843 116.458 259.672 116.306 259.451 116.306L257.23 116.291ZM209.159 117.911C209.159 117.911 209.144 117.837 209.144 118.562C209.144 118.758 209.316 118.911 209.537 118.911C209.758 118.911 209.944 118.758 209.944 118.562C209.944 118.027 209.944 118.119 209.944 117.911C209.941 117.912 209.159 117.911 209.159 117.911ZM261.053 118.941C260.831 118.941 260.645 119.094 260.645 119.289V122.122C260.645 122.318 260.832 122.486 261.053 122.486C261.274 122.486 261.445 122.317 261.445 122.122V119.289C261.445 119.094 261.274 118.941 261.053 118.941ZM209.537 121.395C209.316 121.395 209.144 121.548 209.144 121.744C209.144 123.084 209.144 123.084 209.144 124.577C209.144 124.772 209.316 124.94 209.537 124.94C209.758 124.94 209.944 124.772 209.944 124.577C209.944 123.084 209.944 123.084 209.944 121.744C209.945 121.548 209.758 121.395 209.537 121.395ZM261.053 124.956C260.831 124.956 260.645 125.123 260.645 125.319V128.151C260.645 128.347 260.832 128.5 261.053 128.5C261.274 128.5 261.445 128.347 261.445 128.151V125.319C261.445 125.123 261.274 124.956 261.053 124.956ZM209.537 127.409C209.316 127.409 209.144 127.578 209.144 127.773C209.144 129.164 209.144 129.163 209.144 130.606C209.144 130.801 209.316 130.954 209.537 130.954C209.758 130.954 209.944 130.801 209.944 130.606C209.944 129.163 209.944 129.163 209.944 127.773C209.945 127.577 209.758 127.409 209.537 127.409ZM261.053 130.985C260.831 130.985 260.645 131.138 260.645 131.333V134.166C260.645 134.362 260.832 134.515 261.053 134.515C261.274 134.515 261.445 134.362 261.445 134.166V131.333C261.445 131.138 261.274 130.985 261.053 130.985ZM209.537 133.439C209.316 133.439 209.144 133.607 209.144 133.803C209.144 134.547 209.142 134.739 209.144 135.212C209.153 135.211 209.891 135.219 209.945 135.231C209.943 134.76 209.945 134.627 209.945 133.803C209.945 133.607 209.758 133.439 209.537 133.439ZM261.053 138.922C260.831 138.922 260.645 139.075 260.645 139.271V140.18C260.645 140.375 260.832 140.543 261.053 140.543C261.274 140.543 261.445 140.375 261.445 140.18V139.271C261.445 139.076 261.274 138.922 261.053 138.922ZM209.552 139.12C209.33 139.12 209.159 139.273 209.159 139.468C209.159 140.9 209.144 141.248 209.144 142.649C209.144 142.845 209.316 143.013 209.537 143.013C209.758 143.013 209.944 142.844 209.944 142.649C209.944 141.248 209.96 140.9 209.96 139.468C209.96 139.273 209.774 139.12 209.552 139.12ZM261.053 143.013C260.831 143.013 260.645 143.181 260.645 143.377V146.209C260.645 146.405 260.832 146.557 261.053 146.557C261.274 146.557 261.445 146.405 261.445 146.209V143.377C261.445 143.181 261.274 143.013 261.053 143.013ZM209.537 145.467C209.316 145.467 209.144 145.635 209.144 145.831C209.144 147.294 209.144 147.294 209.144 148.663C209.144 148.859 209.316 149.012 209.537 149.012C209.758 149.012 209.944 148.859 209.944 148.663C209.944 147.294 209.944 147.294 209.944 145.831C209.945 145.635 209.758 145.467 209.537 145.467ZM261.053 149.042C260.831 149.042 260.645 149.195 260.645 149.39V152.223C260.645 152.419 260.832 152.571 261.053 152.572C261.274 152.572 261.445 152.419 261.445 152.223V149.39C261.445 149.195 261.274 149.042 261.053 149.042ZM209.537 151.496C209.316 151.496 209.144 151.649 209.144 151.845C209.144 153.455 209.144 153.455 209.144 154.677C209.144 154.873 209.316 155.041 209.537 155.041C209.758 155.041 209.944 154.873 209.944 154.677C209.944 153.455 209.944 153.455 209.944 151.845C209.945 151.649 209.758 151.496 209.537 151.496ZM211.244 156.025C211.023 156.025 210.836 156.178 210.836 156.374C210.836 156.57 211.023 156.722 211.244 156.722H214.447C214.668 156.722 214.855 156.57 214.854 156.374C214.854 156.178 214.668 156.026 214.447 156.025H211.244ZM218.058 156.025C217.836 156.025 217.65 156.178 217.65 156.374C217.65 156.57 217.837 156.722 218.058 156.722H221.26C221.481 156.722 221.667 156.57 221.667 156.374C221.667 156.178 221.481 156.026 221.26 156.025H218.058ZM224.87 156.025C224.649 156.025 224.463 156.178 224.463 156.374C224.463 156.57 224.649 156.722 224.87 156.722H228.073C228.294 156.722 228.481 156.57 228.481 156.374C228.481 156.178 228.294 156.026 228.073 156.025H224.87ZM231.684 156.025C231.463 156.025 231.276 156.178 231.276 156.374C231.276 156.57 231.463 156.722 231.684 156.722H233.709C233.93 156.722 234.116 156.57 234.116 156.374C234.116 156.178 233.93 156.026 233.709 156.025H231.684ZM238.498 156.025C238.276 156.025 238.09 156.178 238.09 156.374C238.09 156.57 238.276 156.722 238.498 156.722H241.7C241.922 156.722 242.108 156.57 242.108 156.374C242.108 156.178 241.921 156.026 241.7 156.025H238.498ZM245.31 156.025C245.089 156.025 244.903 156.178 244.903 156.374C244.903 156.57 245.09 156.722 245.31 156.722H248.513C248.734 156.722 248.921 156.57 248.921 156.374C248.921 156.178 248.734 156.026 248.513 156.025H245.31ZM252.124 156.025C251.903 156.025 251.716 156.178 251.716 156.374C251.716 156.57 251.903 156.722 252.124 156.722H255.327C255.548 156.722 255.735 156.57 255.735 156.374C255.735 156.178 255.548 156.026 255.327 156.025H252.124Z",
    fill: "#FAAE20"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M233.791 115.119C233.791 114.931 233.943 114.78 234.129 114.78H236.462C236.649 114.78 236.8 114.932 236.8 115.119V117.47C236.8 117.657 236.649 117.808 236.462 117.808H234.129C233.942 117.808 233.791 117.656 233.791 117.47V115.119Z",
    stroke: "#FAAE20",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M208.131 115.119C208.131 114.931 208.283 114.78 208.469 114.78H210.802C210.989 114.78 211.14 114.932 211.14 115.119V117.47C211.14 117.657 210.989 117.808 210.802 117.808H208.469C208.282 117.808 208.131 117.656 208.131 117.47V115.119Z",
    stroke: "#FAAE20",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M259.45 115.119C259.45 114.931 259.602 114.78 259.788 114.78H262.121C262.308 114.78 262.459 114.932 262.459 115.119V117.47C262.459 117.657 262.307 117.808 262.121 117.808H259.788C259.601 117.808 259.45 117.656 259.45 117.47V115.119Z",
    stroke: "#FAAE20",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M233.839 155.652C233.839 155.465 233.99 155.313 234.177 155.313H236.51C236.697 155.313 236.848 155.465 236.848 155.652V158.004C236.848 158.191 236.696 158.342 236.51 158.342H234.177C233.99 158.342 233.839 158.19 233.839 158.004V155.652Z",
    stroke: "#FAAE20",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M208.179 155.652C208.179 155.465 208.331 155.313 208.517 155.313H210.85C211.037 155.313 211.188 155.465 211.188 155.652V158.004C211.188 158.191 211.037 158.342 210.85 158.342H208.517C208.33 158.342 208.179 158.19 208.179 158.004V155.652Z",
    stroke: "#FAAE20",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M207.64 135.336C207.64 135.148 207.791 134.997 207.978 134.997H210.311C210.498 134.997 210.649 135.149 210.649 135.336V137.687C210.649 137.874 210.497 138.026 210.311 138.026H207.978C207.791 138.026 207.64 137.874 207.64 137.687V135.336Z",
    stroke: "#FAAE20",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M259.45 135.336C259.45 135.148 259.602 134.997 259.788 134.997H262.121C262.308 134.997 262.459 135.149 262.459 135.336V137.687C262.459 137.874 262.307 138.026 262.121 138.026H259.788C259.601 138.026 259.45 137.874 259.45 137.687V135.336Z",
    stroke: "#FAAE20",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M259.498 155.652C259.498 155.465 259.65 155.313 259.837 155.313H262.169C262.356 155.313 262.507 155.465 262.507 155.652V158.004C262.507 158.191 262.356 158.342 262.169 158.342H259.837C259.649 158.342 259.498 158.19 259.498 158.004V155.652Z",
    stroke: "#FAAE20",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M122.912 118.757H154.518",
    stroke: "#455A64",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M161.034 118.757H192.641",
    stroke: "#455A64",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M122.777 155.185H154.383",
    stroke: "#455A64",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M160.899 155.185H192.506",
    stroke: "#455A64",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M119.706 121.746V134.026",
    stroke: "#455A64",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M119.706 139.593V151.873",
    stroke: "#455A64",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M195.6 121.746V134.026",
    stroke: "#455A64",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M195.6 139.593V151.873",
    stroke: "#455A64",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M123.044 152.178L192.508 121.441",
    stroke: "#455A64",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M123.425 120.602L192.128 153.016",
    stroke: "#455A64",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M156.137 117.581C156.137 117.394 156.288 117.242 156.475 117.242H158.808C158.995 117.242 159.146 117.394 159.146 117.581V119.932C159.146 120.12 158.995 120.271 158.808 120.271H156.475C156.288 120.271 156.137 120.119 156.137 119.932V117.581Z",
    stroke: "#455A64",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M118.202 117.581C118.202 117.394 118.353 117.242 118.54 117.242H120.873C121.06 117.242 121.211 117.394 121.211 117.581V119.932C121.211 120.12 121.059 120.271 120.873 120.271H118.54C118.353 120.271 118.202 120.119 118.202 119.932V117.581Z",
    stroke: "#455A64",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M194.095 117.581C194.095 117.394 194.247 117.242 194.433 117.242H196.766C196.953 117.242 197.104 117.394 197.104 117.581V119.932C197.104 120.12 196.953 120.271 196.766 120.271H194.433C194.246 120.271 194.095 120.119 194.095 119.932V117.581Z",
    stroke: "#455A64",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M156.149 154.01C156.149 153.822 156.3 153.671 156.487 153.671H158.82C159.007 153.671 159.158 153.823 159.158 154.01V156.361C159.158 156.548 159.006 156.7 158.82 156.7H156.487C156.3 156.7 156.149 156.548 156.149 156.361V154.01Z",
    stroke: "#455A64",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M118.202 154.01C118.202 153.822 118.353 153.671 118.54 153.671H120.873C121.06 153.671 121.211 153.823 121.211 154.01V156.361C121.211 156.548 121.059 156.7 120.873 156.7H118.54C118.353 156.7 118.202 156.548 118.202 156.361V154.01Z",
    stroke: "#455A64",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M118.202 135.607C118.202 135.419 118.353 135.267 118.54 135.267H120.873C121.06 135.267 121.211 135.419 121.211 135.607V137.957C121.211 138.145 121.059 138.296 120.873 138.296H118.54C118.353 138.296 118.202 138.144 118.202 137.957V135.607Z",
    stroke: "#455A64",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M194.095 135.607C194.095 135.419 194.247 135.267 194.433 135.267H196.766C196.953 135.267 197.104 135.419 197.104 135.607V137.957C197.104 138.145 196.953 138.296 196.766 138.296H194.433C194.246 138.296 194.095 138.144 194.095 137.957V135.607Z",
    stroke: "#455A64",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M194.095 154.01C194.095 153.822 194.247 153.671 194.433 153.671H196.766C196.953 153.671 197.104 153.823 197.104 154.01V156.361C197.104 156.548 196.953 156.7 196.766 156.7H194.433C194.246 156.7 194.095 156.548 194.095 156.361V154.01Z",
    stroke: "#455A64",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M122.912 169.491H154.518",
    stroke: "#455A64",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M161.034 169.491H192.641",
    stroke: "#455A64",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M122.777 205.92H154.383",
    stroke: "#455A64",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M160.899 205.92H192.506",
    stroke: "#455A64",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M119.706 172.481V184.761",
    stroke: "#455A64",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M119.706 190.328V202.608",
    stroke: "#455A64",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M195.6 172.481V184.761",
    stroke: "#455A64",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M195.6 190.328V202.608",
    stroke: "#455A64",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M123.044 202.913L192.508 172.176",
    stroke: "#455A64",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M123.425 171.337L192.128 203.751",
    stroke: "#455A64",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M156.137 168.316C156.137 168.129 156.288 167.977 156.475 167.977H158.808C158.995 167.977 159.146 168.129 159.146 168.316V170.667C159.146 170.854 158.995 171.006 158.808 171.006H156.475C156.288 171.006 156.137 170.854 156.137 170.667V168.316Z",
    stroke: "#455A64",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M118.202 168.316C118.202 168.129 118.353 167.977 118.54 167.977H120.873C121.06 167.977 121.211 168.129 121.211 168.316V170.667C121.211 170.854 121.059 171.006 120.873 171.006H118.54C118.353 171.006 118.202 170.854 118.202 170.667V168.316Z",
    stroke: "#455A64",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M194.095 168.316C194.095 168.129 194.247 167.977 194.433 167.977H196.766C196.953 167.977 197.104 168.129 197.104 168.316V170.667C197.104 170.854 196.953 171.006 196.766 171.006H194.433C194.246 171.006 194.095 170.854 194.095 170.667V168.316Z",
    stroke: "#455A64",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M156.149 204.745C156.149 204.557 156.3 204.406 156.487 204.406H158.82C159.007 204.406 159.158 204.557 159.158 204.745V207.096C159.158 207.283 159.006 207.435 158.82 207.435H156.487C156.3 207.435 156.149 207.283 156.149 207.096V204.745Z",
    stroke: "#455A64",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M118.202 204.745C118.202 204.557 118.353 204.406 118.54 204.406H120.873C121.06 204.406 121.211 204.557 121.211 204.745V207.096C121.211 207.283 121.059 207.435 120.873 207.435H118.54C118.353 207.435 118.202 207.283 118.202 207.096V204.745Z",
    stroke: "#455A64",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M118.202 186.341C118.202 186.154 118.353 186.002 118.54 186.002H120.873C121.06 186.002 121.211 186.154 121.211 186.341V188.692C121.211 188.88 121.059 189.031 120.873 189.031H118.54C118.353 189.031 118.202 188.879 118.202 188.692V186.341Z",
    stroke: "#455A64",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M194.095 186.341C194.095 186.154 194.247 186.002 194.433 186.002H196.766C196.953 186.002 197.104 186.154 197.104 186.341V188.692C197.104 188.88 196.953 189.031 196.766 189.031H194.433C194.246 189.031 194.095 188.879 194.095 188.692V186.341Z",
    stroke: "#455A64",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M194.095 204.745C194.095 204.557 194.247 204.406 194.433 204.406H196.766C196.953 204.406 197.104 204.557 197.104 204.745V207.096C197.104 207.283 196.953 207.435 196.766 207.435H194.433C194.246 207.435 194.095 207.283 194.095 207.096V204.745Z",
    stroke: "#455A64",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M233.299 94.7131C233.299 93.1275 234.581 91.842 236.162 91.842C237.743 91.842 239.025 93.1275 239.025 94.7131C239.025 96.2982 237.743 97.5837 236.162 97.5837C234.581 97.5837 233.299 96.2987 233.299 94.7131Z",
    stroke: "#FAAE20",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M237.908 97.3123L241.223 101.645",
    stroke: "#FAAE20",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M245.644 105.544H143.026C141.96 105.544 141.096 104.677 141.096 103.608V89.8789C141.096 88.8097 141.96 87.9429 143.026 87.9429H245.644C246.71 87.9429 247.574 88.8097 247.574 89.8789V103.608C247.575 104.677 246.71 105.544 245.644 105.544Z",
    stroke: "#FAAE20",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M56.0532 89.9669C56.0532 88.889 56.9249 88.0154 57.9993 88.0154H67.8776C68.953 88.0154 69.8242 88.889 69.8242 89.9669V151.461C69.8242 152.538 68.9525 153.412 67.8776 153.412H57.9993C56.9249 153.412 56.0532 152.538 56.0532 151.461V89.9669Z",
    fill: "#FAAE20"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M63.1914 102.544L59.7688 107.966H66.4161L63.1914 102.544Z",
    stroke: "#455A64",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M60.0989 132.183C60.0989 130.525 61.4388 129.181 63.0924 129.181C64.7455 129.181 66.0864 130.525 66.0864 132.183C66.0864 133.841 64.746 135.185 63.0924 135.185C61.4388 135.185 60.0989 133.841 60.0989 132.183Z",
    fill: "white"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M60.8147 92.998H65.3696",
    stroke: "#455A64",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M60.8147 94.9578H65.3696",
    stroke: "#455A64",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M60.8147 96.9175H65.3696",
    stroke: "#455A64",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M61.4422 116.338C61.4581 115.445 62.2096 114.734 63.1213 114.75C64.0326 114.766 64.7581 115.504 64.7421 116.398C64.7262 117.292 63.9747 118.003 63.0634 117.986C62.1522 117.97 61.4262 117.232 61.4422 116.338Z",
    fill: "#455A64"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M63.1499 118.618C61.3901 118.586 59.9377 120.065 59.7263 121.984L66.4586 122.106C66.3162 120.181 64.9102 118.65 63.1499 118.618Z",
    fill: "#455A64"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M62.9478 148.339V142.718",
    stroke: "#455A64",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M60.7351 143.946L62.9476 141.858L65.1423 143.946",
    stroke: "#455A64",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M111.954 40.9692C113.512 40.9692 114.772 42.2431 114.772 43.8055V54.2076C114.772 55.77 113.512 57.0438 111.954 57.0438H73.2401C73.2401 57.0438 72.837 58.5786 74.4221 60.1444C76.0072 61.7101 79.1069 61.8911 78.3795 62.2289C77.6521 62.5668 73.2874 62.1844 71.5198 61.4986C67.7242 60.0258 67.742 57.0434 67.742 57.0434C65.5903 57.0434 66.3133 57.0434 61.6068 57.0434C58.8701 57.0434 58.2827 54.2657 58.2827 53.1491V43.8055C58.2827 42.2431 59.5425 40.9692 61.1005 40.9692H111.954Z",
    fill: "#FAAE20"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M75.7363 44.5789V49.8956C75.7363 50.7789 75.4607 51.4773 74.9095 51.9913C74.3583 52.5053 73.6058 52.7618 72.6511 52.7618C71.7114 52.7618 70.9647 52.5126 70.412 52.0136C69.8589 51.5146 69.577 50.8292 69.5659 49.9566V44.5789H71.2244V49.9067C71.2244 50.4353 71.3503 50.8205 71.6033 51.0625C71.8557 51.3045 72.2051 51.4255 72.6511 51.4255C73.5836 51.4255 74.0571 50.9338 74.0721 49.9508V44.5784H75.7363V44.5789Z",
    fill: "#455A64"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M79.9919 52.651H78.3335V44.5789H79.9919V52.651Z",
    fill: "#455A64"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M83.0594 53.3436H81.8706L84.8342 44.5784H86.023L83.0594 53.3436Z",
    fill: "#455A64"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M94.1157 44.5789V49.8956C94.1157 50.7789 93.8401 51.4773 93.2889 51.9913C92.7377 52.5053 91.9852 52.7618 91.0305 52.7618C90.0908 52.7618 89.3441 52.5126 88.7914 52.0136C88.2388 51.5146 87.9564 50.8292 87.9453 49.9566V44.5789H89.6038V49.9067C89.6038 50.4353 89.7297 50.8205 89.9826 51.0625C90.2351 51.3045 90.5845 51.4255 91.0305 51.4255C91.963 51.4255 92.4365 50.9338 92.4515 49.9508V44.5784H94.1157V44.5789Z",
    fill: "#455A64"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M99.4888 47.3619L100.998 44.5789H102.906L100.561 48.5815L102.966 52.651H101.037L99.4888 49.8235L97.9409 52.651H96.0112L98.4164 48.5815L96.072 44.5789H97.9795L99.4888 47.3619Z",
    fill: "#455A64"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg2);
export default __webpack_public_path__ + "static/media/2.365c65bdffccd3714987f0c4fafc054c.svg";
export { ForwardRef as ReactComponent };